export default __webpack_public_path__ + "static/routes-b6f72e75175eed7e8453f3d078a8d215.jpg";